import moment from 'moment-timezone';

interface GetTimezonesDifference {
	timezone1: string;
	timezone2: string;
}

/**
 * Get difference between two timezones in minutes and formatted string.
 *
 * @example
 * const { diffInMinutes, formattedDiff } = getTimezonesDifference({
 *     timezone1: 'Europe/London',
 *     timezone2: 'Europe/Moscow',
 * });
 */
const getTimezonesDifference = ({
	timezone1,
	timezone2,
}: GetTimezonesDifference): {
	diffInMinutes: number;
	formattedDiff: string;
} => {
	const timezone1Offset = moment.tz(timezone1).utcOffset();
	const timezone2Offset = moment.tz(timezone2).utcOffset();
	const diffInMinutes = Math.abs(timezone1Offset - timezone2Offset);
	const formattedDiff = `${timezone1Offset > timezone2Offset ? '-' : '+'} ${
		diffInMinutes / 60
	}`;

	return { diffInMinutes, formattedDiff };
};
export { getTimezonesDifference };
